import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { ArtefactType } from '@modules/common/types';
import { getArtefactTypeLabel } from '@modules/common/utils';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/system';

interface ArtefactTitleProps {
  name: string;
  artefactType: ArtefactType;
  onArtefactRename?: () => void;
  createdBy?: string;
  updatedAt?: string;
}

export const ArtefactTitle = ({
  name,
  artefactType,
  onArtefactRename,
  createdBy = '',
  updatedAt,
}: ArtefactTitleProps) => {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  const theme = useTheme();

  const artefactTypeLabel = getArtefactTypeLabel(
    artefactType,
    isSearchToFeedEnabled,
  );

  return (
    <Stack>
      <Stack direction="row" spacing={1} alignItems="flex-end">
        <Typography className="artefact-title" variant="subtitle2">
          {name}
        </Typography>
        {onArtefactRename && (
          <IconButton
            onClick={onArtefactRename}
            size="small"
            sx={{ top: 2 }}
            data-role="rename-artefact-button"
          >
            <EditIcon
              fontSize="small"
              sx={{ color: theme.palette.primary.main }}
            />
          </IconButton>
        )}
      </Stack>
      <Stack>
        {createdBy && (
          <Stack direction="row">
            <Typography variant="caption" color="text.disabled">
              {artefactTypeLabel}
              {createdBy && ` • ${createdBy}`}
              {updatedAt && ` • ${updatedAt}`}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
